import { render, staticRenderFns } from "./StandardInputV2.vue?vue&type=template&id=2e4c65a5&scoped=true&"
import script from "./StandardInputV2.vue?vue&type=script&lang=js&"
export * from "./StandardInputV2.vue?vue&type=script&lang=js&"
import style0 from "./StandardInputV2.vue?vue&type=style&index=0&id=2e4c65a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c65a5",
  null
  
)

export default component.exports